<template>
  <div>
    <el-button @click="getCardInfo" type="success">医保刷卡</el-button>
  </div>
</template>
<script setup>
  import service from '@/utils/request'
  import { ref, onMounted, defineExpose } from 'vue';
  import comm from '@/utils/comm'
  const infoData = ref('')
  const em = defineEmits(['refreshDataList'])
  const reponseData = ref('')
  onMounted(() => {
    initData()
  })
  const initData = async () => {
    
  }

  const getCardInfo = async () => {
    let res = await service.post('/api/config/fixmedins_scan_config_by_region')
    if (res.code === 0) {
      infoData.value = res.data
    }
  }
  defineExpose({
    initData,
    infoData,
    reponseData,
  })
</script>
<style scoped>
.patentList {
  background-color: #fff;
  overflow: auto;
}
</style>